import { Component, input, signal } from '@angular/core';
import { PromoType } from '@data/domain/promo.entity';
import { DateTime } from '@shared/pipes/date-time/date-time.interface';

@Component({
  selector: 'period-landing',
  standalone: true,
  imports: [],
  templateUrl: './period-landing.component.html',
  styleUrl: './period-landing.component.scss'
})
export class PeriodLandingComponent {
  label = input<string>();
  dateTime = input<DateTime>();
  promoType = signal<PromoType>(localStorage.getItem('promoType') as PromoType);
}
